import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterLinkedKeyList',
})
export class FilterLinkedKeyList implements PipeTransform {
  transform(fullList: any[], addedtemsList: any[]): any {
    let newList = [];
    fullList.forEach((element) => {
      if (addedtemsList.findIndex((x) => x.sk == element.sk) == -1) {
        newList.push(element);
      }
    });
    return newList;
  }
}
